import { setContext } from '@apollo/client/link/context/index.js';
import { ApolloLink } from '@apollo/client/link/core/ApolloLink.js';
import { onError } from '@apollo/client/link/error/index.js';
import { HttpLink } from '@apollo/client/link/http/HttpLink.js';
const baseHttpLink = (uri) => new HttpLink({
    uri,
});
const authLink = ({ token }) => setContext((_, { headers }) => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    if (!token)
        return { headers };
    return {
        headers: {
            ...headers,
            authorization: `JWT ${token}`,
        },
    };
});
const logoutLink = onError(() => undefined);
export const httpLink = ({ token, url, }) => ApolloLink.from([authLink({ token }), logoutLink, baseHttpLink(url)]);
//# sourceMappingURL=httplink.js.map